// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 用户行为上报 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /user/customer_track/upload/enven */
export async function userCustomerTrackUploadEnvenUsingPOST(
  body: API.CreateTrackEventReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/user/customer_track/upload/enven", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户心跳上报 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /user/customer_track/upload/heartbeat */
export async function userCustomerTrackUploadHeartbeatUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userCustomerTrackUploadHeartbeatUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/user/customer_track/upload/heartbeat", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
